import BaseCollection from "nexia_mobile/models/base_collection";
import Pageable from "nexia_mobile/models/mixins/pageable";
import Filterable from "nexia_mobile/models/mixins/filterable";
import DateRangeFilterSchema from "nexia_mobile/models/date_range_filter_schema";

class EventCollection extends BaseCollection {}

_.extend(EventCollection.prototype, Pageable);
_.extend(EventCollection.prototype, Filterable, {
  getFilterSchemaClass() {
    return DateRangeFilterSchema;
  },
});
export default EventCollection;



// WEBPACK FOOTER //
// ./src/models/event_collection.js